const ENDPOINT = process.env.REACT_APP_AI_URL;

const search = async (prompt) => {
    const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt }),
    });

    if (!res.ok) {
        throw new Error(`AskAi search failed: ${res.status}`);
    }

    const json = await res.json();
    
    return json;
};

const askAiAPI = { search };

export default askAiAPI;
